import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { enviarCodigoVerificacion } from 'services/apiServices';
import { mfaErrorsSelector, emailMFASelector } from 'store/selectors';
import { datosUsuarioLogueado } from 'constants/selectors';
import { fetchMFA, EmailVerifyCode } from 'actions/mfa';
import {
  POSTERGACION_2FA_LOGIN,
  CHANGE_USER_EMAIL_ROUTE,
} from 'constants/RouterConstants';
import {
  MFA_EMAIL_CARD_TITLE_TEXT,
  MFA_EMAIL_ENFORCE_DESC_TEXT,
  MFA_EMAIL_NOT_ACCESSIBLE_TEXT,
} from 'constants/commonConstants';
import Auth from 'utils/Auth';
import CardSmall from 'components/CardSmall';
import ButtonSolid from 'components/ButtonSolid';

import './configurarEmailLogin.css';

const ConfigurarEmailLogin = () => {
  const styles = {
    'resend-button': { fontSize: '15px', color: '#003DA5' },
    containers: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      'max-width': '700px',
    },
    'code-title': { fontWeight: 'bold', color: 'darkblue' },
    error: { border: '2px solid #B60000' },
    'error-validacion': { fontSize: '15px', color: '#B60000' },
    'secondary-button': {
      lineHeight: '24px',
      textDecorationLine: 'underline',
      color: 'blue',
      padding: '8px 24px',
    },
  };
  const mfaErrors = useSelector(mfaErrorsSelector);
  const usuario = useSelector(datosUsuarioLogueado);
  const dispatch = useDispatch();
  const history = useHistory();
  const emailMFA = useSelector(emailMFASelector);
  const [value, setValue] = useState();
  const [colorResendSuccess, setColorResendSuccess] = useState(null);

  useEffect(() => {
    dispatch(fetchMFA(Auth.getInstance().getUserId()));
  }, []);

  return (
    <CardSmall style={styles.containers}>
      <div className="totp-card__title">{MFA_EMAIL_CARD_TITLE_TEXT}</div>
      <div className="totp-card__desc">
        {MFA_EMAIL_ENFORCE_DESC_TEXT(usuario?.user?.email)}
      </div>
      <div
        className="render-field-nuevo__input-div-container"
        style={styles.containers}
      >
        <span style={styles['code-title']}>Ingresar código</span>
        <input
          style={mfaErrors ? styles.error : null}
          value={value}
          placeholder="Ej. 123456"
          onChange={e => setValue(e.target.value)}
          inputMode="numeric"
        />
        {mfaErrors && (
          <span style={styles['error-validacion']}>{mfaErrors}</span>
        )}
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <span>¿No lo recibiste aún?&nbsp;</span>
          <button
            type="button"
            onClick={async () => {
              await enviarCodigoVerificacion();
              setColorResendSuccess('#009e3c');
              setTimeout(() => {
                setColorResendSuccess(null);
              }, 500);
            }}
            style={{
              ...styles['resend-button'],
              color: colorResendSuccess || styles['resend-button'].color,
            }}
          >
            {'Solicitá uno nuevo >>'}
          </button>
        </div>
      </div>
      <div className="button-container">
        <ButtonSolid
          handleClick={() => dispatch(EmailVerifyCode(emailMFA.id, value))}
          text="Confirmar la activación del doble factor de autenticación"
        />
        <button
          type="button"
          onClick={() => history.push(POSTERGACION_2FA_LOGIN)}
          style={styles['secondary-button']}
        >
          Configurar más tarde
        </button>
      </div>
      <div className="totp-card__desc-sub">
        {MFA_EMAIL_NOT_ACCESSIBLE_TEXT(usuario?.user?.email)}{' '}
        <button
          type="button"
          onClick={() => history.push(CHANGE_USER_EMAIL_ROUTE)}
          className="link"
        >
          <span>Administrar tu Usuario gub.uy</span>
        </button>
      </div>
    </CardSmall>
  );
};

export default ConfigurarEmailLogin;
